import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Details from "./Details";

ReactDOM.render(
  <React.StrictMode>
    <Details />
  </React.StrictMode>,
  document.getElementById("root")
);
